import { Box, Button, Grid, InputAdornment, Stack, Tab, Tabs, TextField } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import React, { useEffect, useRef, useState } from 'react';
import Thermometer from '@/components/Base/Thermometer.tsx';
import { TitlePages } from '@/components/Base/TitlePage';
import { ArrowBack } from '@mui/icons-material';
import KpiComponent from '@/components/Base/KpiComponent';
import LoadingSummary from '@/features/dashboard/components/LoadingSummary';
import TableTermometro from '@/components/Base/TableTermometro';
import Search from '@mui/icons-material/Search';
import { useTermometroFinanceiroAnaliseDescontos } from '@/features/termometro/getTermometroFinanceiroAnaliseDescontos';
import { useNavigate } from 'react-router-dom';
import { useTermometroGeral } from '@/features/termometro/getTermometroGeral';
import { useTermometroPendenciasAlunos } from '@/features/termometro/getTermometroPendenciasAlunos';
import TableTermometroPendencias from '@/components/Base/TableTermometroPendencias';
import { useTermometroGeralStudentByName } from '@/features/termometro/getTermometroGeralStudentByName';

function useDebounce<T>(value: T, delay = 500): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debounced;
}

const TermometroGeral = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const navigate = useNavigate();

  const { data: summary, isError, refetch, isFetching, isFetched } = useTermometroGeral({
    name: searchQuery || undefined
  });

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Enter' && document.activeElement === inputRef.current) {
        setSearchQuery(inputRef.current?.value || '');
        refetch();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [refetch]);


  const {
    data: summaryPendencias,
    isError: errorPendencias,
    refetch: refetchPendencias,
    isFetching: isFetchingPendencias,
    isFetched: isFetchedPendencias,
  } = useTermometroPendenciasAlunos();

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const { data: dataAnaliseDescontos } = useTermometroFinanceiroAnaliseDescontos();

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filterData = (data) => {
    return data;
  };

  const getPositionFromScore = (month_score) => {
    if (month_score >= 0 && month_score < 3.33) {
      return 'end';
    } else if (month_score >= 3.33 && month_score < 6.66) {
      return 'center';
    } else if (month_score >= 6.66 && month_score <= 10) {
      return 'start';
    } else {
      return 'end';
    }
  };

  return (
    <>
      <Box padding={'15px'}>
        <Tabs value={activeTab} onChange={handleTabChange} indicatorColor="primary">
          <Tab
            sx={{
              backgroundColor: activeTab === 0 ? '#fff' : '#DDDDDD',
              color: activeTab === 0 ? '#000' : '#4C4C4C',
              fontWeight: 'bold',
              borderRadius: '14px 14px 0 0',
              px: 3,
              py: 1,
              textTransform: 'none',
              '&.MuiTab-root.Mui-selected': { color: '#000' },
              '&.MuiTabs-indicator': { height: '10px !important' },
            }}
            label="Termômetro geral"
          />
          <Tab
            sx={{
              backgroundColor: activeTab === 1 ? '#fff' : '#DDDDDD',
              color: activeTab === 1 ? '#000' : '#4C4C4C',
              fontWeight: 'bold',
              borderRadius: '14px 14px 0 0',
              px: 3,
              py: 1,
              textTransform: 'none',
              '&.MuiTab-root.Mui-selected': { color: '#000' },
              '&.MuiTabs-indicator': { height: '10px !important' },
            }}
            label="Pendências por aluno"
          />
        </Tabs>

        {activeTab === 0 && (
          <Box padding={'15px'} sx={{ background: '#fff', borderRadius: '0 0 14px 14px' }}>
            <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
              <Stack alignItems={'center'} flexDirection={'row'}>
                <ArrowBack sx={{ cursor: 'pointer', mr: '10px' }} />
                <TitlePages
                  title={'Termômetro geral'}
                  showInterrogation
                  showInterrogationText="Veja os dados relacionados ao Termômetro geral"
                />
              </Stack>
              <Button
                variant="contained"
                sx={{
                  borderRadius: '24px',
                  fontSize: '14px',
                  color: '#fff',
                  height: '32px',
                  background: '#15AB51',
                  fontWeight: '700',
                  cursor: 'pointer',
                  textTransform: 'capitalize',

                  '.MuiButton-text': {
                    fontSize: '14px',
                    height: '17px',
                    fontWeight: '700',
                    lineHeight: '17px',

                  },
                }}
                onClick={() => navigate('/configuracoes-avancadas-termometro-geral')}
              >

                Configurações avançadas
              </Button>
            </Stack>

            {summary && isFetched && (
              <Stack flexDirection={'row'} gap={'8px'}>
                <KpiComponent
                  title={'Quantidade de alunos no Score baixo '}
                  value={summary?.total_low_students || '-'}
                  style={{ width: '160px' }}
                />
                <KpiComponent
                  title={'Quantidade de alunos no Score Intermediário'}
                  value={summary?.total_intermediary_students || '-'}
                  style={{ width: '160px' }}
                />
                <KpiComponent
                  title={'Quantidade de alunos no Score alto'}
                  value={summary?.total_high_students || '-'}
                  style={{ width: '160px' }}
                />

                <KpiComponent
                  title={'Quantidade de alunos nas Escolinhas'} 
                  value={summary?.count_students_without_boletim?.escolinhas || '-'}
                  bgColor="#FFFFFF"
                />

                <KpiComponent
                  title={'Termômetro Eduzinho'}
                  value={Number(summary?.score).toFixed(2).toString() || '-'}
                  tooltipText={"O valor do Eduzinho é obtido pela média dos três indicadores gerais da instituição: Score Financeiro, Score de Frequência e Score Pedagógico."}
                  style={{ width: '160px' }}
                />
              </Stack>
            )}
            {isFetching && !summary && <LoadingSummary />}

            <Box padding={'15px'} sx={{ background: '#fff', borderRadius: '14px', width: '100%' }}>
              <Thermometer
                score={summary?.score || 0}
              />

              <TextField
                variant="outlined"
                placeholder="Pesquisar por nome do aluno"
                inputRef={inputRef}
                sx={{
                  marginBottom: '15px',
                  marginTop: '30px',
                  '.MuiOutlinedInput-root': { borderRadius: '40px', padding: '0 !important' }, // Remove padding
                  '.MuiOutlinedInput-input': { padding: '10px' },
                  maxWidth: '500px',
                  width: '100%',
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={{
                        p: 0,
                        m: 0,
                      }}
                    >
                      <Box
                        component="button"
                        type="button"
                        sx={{
                          border: 'none',
                          outline: 'none',
                          backgroundColor: '#F0F0F0',
                          borderRadius: '50%',
                          width: '35px',
                          height: '35px',
                          display: 'flex',
                          marginRight: '10px',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          transition: 'background 0.2s, box-shadow 0.2s',
                          boxShadow: '0 0 0 0 transparent',
                          '&:hover': {
                            boxShadow: '0 0 0 2px #e0e0e0',
                          },
                        }}
                        onClick={() => {
                          if (inputRef.current) {
                            inputRef.current.blur();
                          }

                          setSearchQuery(inputRef.current?.value || '');
                          refetch();
                        }}
                        tabIndex={0}
                      >
                        <Search sx={{ color: '#4C4C4C' }} />
                      </Box>
                    </InputAdornment>
                  ),
                }}
              />

              {isFetching && (
                <Grid container spacing={'20px'} justifyContent="center" alignItems="center" sx={{ minHeight: '120px', marginBottom: '20px' }}>
                  <Grid item sm={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Box><CircularProgress /></Box>
                  </Grid>
                  <Grid item sm={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Box><CircularProgress /></Box>
                  </Grid>
                  <Grid item sm={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Box><CircularProgress /></Box>
                  </Grid>
                </Grid>
              )}
              {isFetched && !isFetching && <Grid container spacing={'20px'}>
                <Grid item sm={4}>
                  <TableTermometro type={'high'} data={filterData(summary?.high_students || [])} />
                </Grid>
                <Grid item sm={4}>
                  <TableTermometro type={'intermediary'} data={filterData(summary?.intermediary_students || [])} />
                </Grid>
                <Grid item sm={4}>
                  <TableTermometro type={'low'} data={filterData(summary?.low_students || [])} />
                </Grid>
              </Grid>}
            </Box>
          </Box>
        )}

        {activeTab === 1 && (
          <Box padding={'15px'} sx={{ background: '#fff', borderRadius: '0 0 14px 14px' }}>
            <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
              <Stack alignItems={'center'} flexDirection={'row'}>
                <ArrowBack sx={{ cursor: 'pointer', mr: '10px' }} />
                <TitlePages
                  title={'Pendências por aluno'}
                  showInterrogation
                  showInterrogationText="Veja os dados relacionados ao Termômetro geral"
                />
              </Stack>

            </Stack>

            {summaryPendencias && isFetchedPendencias && (
              <Stack direction={'row'} spacing={'8px'}>
                <KpiComponent
                  title={'Quantidade de alunos no Score baixo'}
                  value={summaryPendencias.total_low_students || '-'}
                />
                <KpiComponent
                  title={'Quantidade de alunos no Score Intermediário'}
                  value={summaryPendencias.total_intermediary_students || '-'}
                />
                <KpiComponent
                  title={'Quantidade de alunos no Score alto'}
                  value={summaryPendencias.total_high_students || '-'}
                />
              </Stack>
            )}
            {isFetchingPendencias && !summaryPendencias && <LoadingSummary />}

            <Box sx={{ background: '#fff', borderRadius: '14px', marginTop: '30px' }}>
              {/* <TextField
                variant="outlined"
                placeholder="Pesquisar por nome do aluno"
                onChange={handleSearchChange}
                sx={{
                  marginBottom: '15px',
                  marginTop: '30px',
                  '.MuiOutlinedInput-root': { borderRadius: '40px', padding: '0 !important' }, // Remove padding
                  '.MuiOutlinedInput-input': { padding: '10px' },
                  maxWidth: '500px',
                  width: '100%',
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Search sx={{ marginRight: '10px' }} />
                    </InputAdornment>
                  ),
                }}
              /> */}

              <Stack flexDirection={'row'} gap={'20px'}>
                <TableTermometroPendencias type={'low'} data={filterData(summaryPendencias?.low_students || [])} />
              </Stack>
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};

export default TermometroGeral;
